import React, { useState, useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import { CanvasContext } from "../../../contexts/CanvasContext";
import indexedDBService from "../../../services/IndexedDBService";
import "./PageManager.css";

const PageManager = ({ LayOut }) => {
  const { currentPage, setCurrentPage,setPages,pages } = useContext(CanvasContext);
  const [newPageName, setNewPageName] = useState("");
  const [editingPageId, setEditingPageId] = useState(null);
  const [editingPageName, setEditingPageName] = useState("");
  const [error, setError] = useState("");
  const [searchPage, setSearchPage] = useState("");

  useEffect(() => {
    const loadPages = async () => {
      let savedPages = await indexedDBService.getPages();
      if (savedPages && savedPages.length > 0) {
        const demoPages = savedPages.filter((page) => page.name === "Demo");
        if (demoPages.length > 1) {
          savedPages = [
            demoPages[0],
            ...savedPages.filter((page) => page.name !== "Demo"),
          ];
          for (let i = 1; i < demoPages.length; i++) {
            await indexedDBService.deletePage(demoPages[i].id);
          }
        }
        setPages(savedPages);
        if (!currentPage) {
          setCurrentPage(savedPages[0]);
        }
      } else {
        const defaultPage = { id: Date.now(), name: "Demo" };
        setPages([defaultPage]);
        setCurrentPage(defaultPage);
        await indexedDBService.savePage(defaultPage);
      }
    };
    loadPages();
  }, [setCurrentPage, currentPage,setPages]);

  const addPage = async () => {
    let trimmedName = newPageName.trim();
    if (trimmedName) {
      // Replace spaces with underscores
      trimmedName = trimmedName.replace(/\s+/g, "_");

      if (
        pages.some(
          (page) => page.name.toLowerCase() === trimmedName.toLowerCase()
        )
      ) {
        setError("A page with this name already exists.");
        return;
      }
      const newPage = { id: Date.now(), name: trimmedName };
      const updatedPages = [...pages, newPage];
      setPages(updatedPages);
      setNewPageName("");
      setError("");
      await indexedDBService.savePage(newPage);
    }
  };

  
  const deletePage = async (pageId) => {
    if (pages.length > 1) {
      const updatedPages = pages.filter((page) => page.id !== pageId);
      setPages(updatedPages);
      if (currentPage.id === pageId) {
        setCurrentPage(updatedPages[0]);
      }
      await indexedDBService.deletePage(pageId);
    }
  };

  const startEditing = (pageId, pageName) => {
    setEditingPageId(pageId);
    setEditingPageName(pageName);
  };

  const savePageName = async (pageId) => {
    let trimmedName = editingPageName.trim();
    if (trimmedName && trimmedName !== "Demo") {
      // Replace spaces with underscores
      trimmedName = trimmedName.replace(/\s+/g, "_");

      if (
        pages.some(
          (page) =>
            page.id !== pageId &&
            page.name.toLowerCase() === trimmedName.toLowerCase()
        )
      ) {
        setError("A page with this name already exists.");
        return;
      }
      const updatedPages = pages.map((page) =>
        page.id === pageId ? { ...page, name: trimmedName } : page
      );
      setPages(updatedPages);
      setEditingPageId(null);
      setError("");
      await indexedDBService.savePage({ id: pageId, name: trimmedName });
    }
  };

  const handleContextMenu = (e, pageId, pageName) => {
    e.preventDefault();
    if (pageName !== "Demo") {
      startEditing(pageId, pageName);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      addPage();
    }
  };

  let ClassForUl = "ULFOReveryone";
  if (LayOut === 1) {
    ClassForUl = "ULFORone";
  } else if (LayOut === 2) {
    ClassForUl = "ULFORtwo";
  } else if (LayOut === 3) {
    ClassForUl = "ULFORthree";
  }

  let listOfpage = [];
  if (pages.length > 1) {
    listOfpage = pages.slice(1);
  } else {
    listOfpage = pages;
  }

  return (
    <div className="page-manager">
      <div>
        <h3>Pages</h3>
        <input
          className="searchbar"
          type="text"
          placeholder="Search Here!"
          onChange={(e) => {
            setSearchPage(e.target.value);
          }}
        />
        <ul className={ClassForUl}>
          {listOfpage
            .filter((item) => {
              return searchPage.toLowerCase() === ""
                ? item
                : item.name.toLowerCase().includes(searchPage);
            })
            .map((page) => (
              <li
                key={page.id}
                className={
                  currentPage && currentPage.id === page.id ? "active" : ""
                }
                onContextMenu={(e) => handleContextMenu(e, page.id, page.name)}
              >
                {editingPageId === page.id ? (
                  <input
                    style={{ width: "60%" }}
                    type="text"
                    value={editingPageName}
                    onChange={(e) => setEditingPageName(e.target.value)}
                    onBlur={() => savePageName(page.id)}
                    onKeyPress={(e) =>
                      e.key === "Enter" && savePageName(page.id)
                    }
                    autoFocus
                  />
                ) : (
                  <span onClick={() => setCurrentPage(page)}>{page.name}</span>
                )}
                {pages.length > 1 && page.name !== "Demo" && (
                  <div className="page-actions">
                    <button
                      id="Pen"
                      onClick={() => startEditing(page.id, page.name)}
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                    <button onClick={() => deletePage(page.id)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                )}
              </li>
            ))}
        </ul>
      </div>
      <div>
        {error && <p className="error-message">{error}</p>}
        <div className="add-page">
          <input
            type="text"
            value={newPageName}
            onChange={(e) => setNewPageName(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="New page name"
          />
          <button onClick={addPage}>
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageManager;
